
    import {Component, Prop, Vue, Emit, Watch} from 'vue-property-decorator';
    @Component
    export default class SearchIdcard extends Vue {
      private idcard: string = ''
      @Emit ('getIdcard')
      sendIdcard(idcard:string){}
    }
